import { BasicTable, ComplexTable } from '@synergy/table';
import { Button, Col, Flex, Row, Tooltip } from "antd";
import i18next from "i18next";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { containerMiddlewareAdEPorto } from "../../server/constants.api";
import useFetch from "../../server/useFetch";
import { PageContent, PageSection, PageTitle } from "../../styles/global/Pages.styled";
import Theme from "../../styles/Theme/Theme";
import { SearchBar } from "../Global/Atomics/SearchBar";
import { SelectAtomic } from '../Global/Atomics/SelectAtomic';
import Spinner from "../Global/Atomics/Spinner";
import { Text } from "../Global/Atomics/Text";
import CustomIcon from "../Global/Icons/CustomIcon";

export const Register = () => {
    const [userTenant] = useState(localStorage.getItem(`adeporto_tenant`)); // State for user's tenant
    const [fetchedData, setFetchData] = useState(null); // State for fetched data
    const [selectedResourceType, setSelectedResourceType] = useState(null); // State for selected items
    const { data: tableComplexData, isLoading: tableComplexIsLoading, refetch: refetchTableComplex } = useFetch(
        'items', 'getRegistryItems',
        {
            tenant: JSON.parse(userTenant)?.[0],
            classes: 'not_Street Lighting',
            types: 'Buildings,Infrastructures'
        }, null, null, containerMiddlewareAdEPorto);
    const { t } = useTranslation(); // Translation hook
    const [searchValue, setSearchValue] = useState(null); // State for search value
    const [fetchCPE, setFetchCPE] = useState(false); // State for fetching CPE data
    // const { data: cpeData, isLoading: cpeDataIsLoading, refetch: refetchCpeData, isFetching: cpeDataIFetching } = useFetch(query.path.searchByCPE, 'getSearchByCPE', { value: searchValue, resourceType: selectedResourceType, tenant: JSON.parse(userTenant)[0], language: i18next.resolvedLanguage }, fetchCPE, 'GET'); // Custom hook for fetching CPE data
    const { data: cpeData, isLoading: cpeDataIsLoading, refetch: refetchCpeData, isFetching: cpeDataIFetching } = useFetch(
        `items/name/${searchValue}`, 'getSearchByCPE',
        {
            tenant: JSON.parse(userTenant)?.[0],
            types: 'Buildings,Infrastructures',
            resourceType: selectedResourceType,
        }, false, null, containerMiddlewareAdEPorto);
    const [cpeValue, setCpeValue] = useState(null); // State for CPE value

    // Effect to refetch table data when language changes
    useEffect(() => {
        try {
            refetchTableComplex();
            refetchCpeData();
        } catch (error) {
            // logger.error('Error in useEffect refetchTableComplex');
            console.error('(Register page) Error in useEffect refetchTableComplex:', error);
            //reportError(error); // Send error report to backend
        }
    }, [i18next.resolvedLanguage])

    // Effect to set fetched data when table data is available
    useEffect(() => {
        try {
            if (tableComplexData?.data) {
                const data = tableComplexData?.data.map((item) => {
                    const tenant = item.tenant.split('/ADEPORTO/');
                    return { ...item, class: t(item.class), tenant: tenant?.[tenant.length - 1] }
                });
                setFetchData(data.sort((a, b) => a.tenant.localeCompare(b.tenant)));
            }
        } catch (error) {
            // logger.error('Error in useEffect if exists data setFetchData');
            console.error('(Register page) Error in useEffect if exists data setFetchData:', error);
            //reportError(error); // Send error report to backend
        }
    }, [tableComplexData])

    // Effect to update CPE value and fetch status
    useEffect(() => {
        if (cpeData?.data) {
            setCpeValue(cpeData.data);
        } else if (cpeData?.data === null) {
            setCpeValue({ id: null, name: null });
        };
        setFetchCPE(false);
    }, [cpeData]);

    // Function to handle selected values
    function getSelectedValues(selectedValues) {
        try {
            setSelectedResourceType(selectedValues);
        } catch (error) {
            // logger.error('Error in getSelectedValues function');
            console.error('(Register page) Error in getSelectedValues function:', error);
            //reportError(error); // Send error report to backend
        }
    };

    const customInput = {
        placeholder: t('search'),
    };

    // Function to filter data with search value
    function filterWithSearch(value) {
        console.log('search value:', value);
        setSearchValue(value);
    };

    // Function to handle options change for years dropdown
    function handleOptionsChange(value) {
        try {
            setSelectedResourceType(value);
            // logger.info('handleling options change for years dropdown');
        } catch (error) {
            console.error('(Register page) Error in handling options change:', error);
        }
    };

    // Rendering JSX
    return (
        <PageContent id='registerTable' $backgroundColor='white' >
            <PageSection>
                <Row gutter={[16, 16]} style={{ width: '100%' }}>
                    <Col span={24}>
                        <PageTitle>
                            <div className="title">
                                <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginRight='s03'>
                                    {t('searchForAsset')} </Text>
                            </div>
                        </PageTitle>
                    </Col>
                    <Col span={24}>
                        {/* addFunction={()=> navigate('/home/register/registerDetail/')} */}
                        <ComplexTable fetchData={fetchedData} hrefLink='/home/register/registerDetail/${id}'
                            getFromChildSelectedValues={null} onRowSelect={getSelectedValues} customInput={customInput} pagination={{ pageSize: 6 }}
                            language={i18next.resolvedLanguage} isLoading={tableComplexIsLoading} tableConfiguration={registryTableConfiguration(t)} />
                    </Col>
                </Row>

            </PageSection>
            <PageSection>
                <Flex align="flex-start" gap={32} vertical="true">
                    <PageTitle>
                        <div className="title">
                            <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginRight='s03'>
                                {t('searhForResource')} </Text>
                            <Tooltip className="widget-tooltip" title={t('searchResourceTooltip')} color={Theme.color.white} colorText={Theme.color["coolgray-12"]}>
                                <Button
                                    shape="circle"
                                    type='text'
                                    icon={<CustomIcon icon={'Information'} iconsize='md' color='blue-4' />}
                                />
                            </Tooltip>
                        </div>
                    </PageTitle>


                    <Flex gap={32} align="end" justify="flex-start" horizontal="true">
                        <Flex gap={16} justify="flex-start" vertical='true'>
                            <SelectAtomic optionsData={[
                                { label: 'CPE/CUI/Inversor', value: 'OTHER' },
                                { label: 'PTD', value: 'PTD' },
                            ]} handleOptionsChange={handleOptionsChange} />
                            <SearchBar filterWithSearch={filterWithSearch} customInput={customInput} disabled={cpeDataIFetching || tableComplexIsLoading} />
                        </Flex>
                        <Button disabled={(searchValue?.length > 3 || !cpeDataIsLoading ? false : true) || cpeDataIFetching || tableComplexIsLoading}
                            shape="round" className="ant-btn ant-btn-blue -medium"
                            onClick={() => refetchCpeData()}>{t('apply')}</Button>
                    </Flex>
                    <div className="full-width">
                        {cpeDataIFetching ? (
                            <Spinner stroke="green" size='28px' />
                        ) : (
                            (cpeValue?.id == null) ? (
                                <Text $fontColor="coolgray-4" $fontSize='text_md' $weight='regular' className="full-width">{t('noDataResource')}</Text>
                            ) : (<BasicTable fetchData={[cpeData?.data]} hrefLink={'/home/register/registerDetail/${id}'} hidePagination={true} language={i18next.resolvedLanguage} tableConfiguration={registryTableConfiguration(t).collumnsConfiguration} />)
                        )}
                    </div>
                </Flex>
            </PageSection>
        </PageContent >
    )
};

const registryTableConfiguration = (t) => {
    return {
        collumnsConfiguration: [
            {
                "title": t('name'),
                "dataIndex": "name",
                "key": "name"
            },
            {
                "title": t("Typology"),
                "dataIndex": "class",
                "key": "class",
                "filterMultipleSelect": true
            },
            {
                "title": t("Address"),
                "dataIndex": "address",
                "key": "address"
            },
            {
                "title": t("Entity/Subentity"),
                "dataIndex": "tenant",
                "key": "tenant",
                "filterMultipleSelect": true
            },
            {
                "title": t("Voltage Level"),
                "dataIndex": "voltageLevel",
                "key": "voltageLevel",
                "filterMultipleSelect": true
            },
            {
                "title": t("Contracted Power") + " (kVA)",
                "dataIndex": "contractedPower",
                "key": "contractedPower",
                "filterMultipleSelect": true
            },
            {
                "title": t("Municipality-Parish"),
                "dataIndex": "location",
                "key": "location",
                "filterMultipleSelect": true
            },
            {
                "title": t("Energy Certificate"),
                "dataIndex": "energyCertificate",
                "key": "energyCertificate",
                "filterMultipleSelect": true
            },
            {
                "title": t("Gas"),
                "dataIndex": "gas",
                "key": "gas",
                "filterMultipleSelect": true
            },
            {
                "title": t("Energy Production"),
                "dataIndex": "energyProduction",
                "key": "energyProduction",
                "filterMultipleSelect": true
            }
        ],
        hideSelectAll: false
    }
};